import { isEmptyObject } from '@Sage/ssm-utils';
import Context from 'managers/Context';

export function getSelectionIdsFromListSelect(entityListSelect) {
    const selected = entityListSelect?.selected;
    const hasFilterSelection = entityListSelect?.hasFilterSelection;
    let includedIds = [];
    let excludedIds = [];
    if (selected && !isEmptyObject(selected)) {
        Object.keys(selected).forEach((key) => {
            if (selected[key] && !hasFilterSelection) includedIds.push(key);
            else if (selected[key] === false) excludedIds.push(key);
        });
    }
    return [includedIds, excludedIds];
}

export function getSelectionIds(state, entity) {
    const entityListSelect = state.entityListSelect[entity.entity];
    return getSelectionIdsFromListSelect(entityListSelect);
}

export function getIncludedSelectionIds(entityListSelect) {
    const selected = entityListSelect?.selected || {};
    return Object.keys(selected).filter((id) => selected[id] === true);
}

export function getSelectionFilters(state, entity, filterKey) {
    const entityListSelect = state.entityListSelect[entity.entity];
    let filter = {};
    if (entityListSelect?.hasFilterSelection) {
        filter = Context.actions.EntityFiltersActions.getCleanFilters(state, entity, filterKey);
    }
    const operators = Context.actions.EntityFiltersActions.getCleanOperators(
        state,
        entity,
        filterKey,
    );
    const crossFilters = Context.actions.EntityFiltersActions.getCleanCrossFilters(
        entity,
        filterKey,
    );
    return { crossFilters, filter, operators };
}
